import React from 'react';
import { ThemeProvider } from './theme/ThemeProvider';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import Login from './pages/Login';
import Register from './pages/Register';

import { ItineraryUploadPage } from './pages/ItineraryUploadPage';
import ProtectedRoute from './components/ProtectedRoute';
import { isAuthenticated } from './services/auth';
import ItineraryListPage from './pages/ItineraryListPage';
import ItinerarySharePage from './pages/ItinerarySharePage';
import CompanyInfoPage from './pages/CompanyInfoPage';
import FavoritePage from './pages/FavoritePage';
import EmployeeManagementPage from './pages/EmployeeManagementPage';
import ItineraryRecyclePage from './pages/ItineraryRecyclePage';
import PreviewPage from './pages/PreviewPage';
import SiteMapPage from './pages/SiteMapPage';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import { UserProvider } from './contexts/UserContext';
import { UpdateProvider } from './contexts/UpdateContext';
import { UpdateNotification } from './components/UpdateNotification';
import CounselingListPage from './pages/CounselingListPage';
import CustomerListPage from './pages/CustomerListPage';
// import { CounselingListPage } from './pages/counseling';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/ko';

function App() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
      <ThemeProvider>
        <UpdateProvider>
          <UserProvider>
            <CssBaseline />
            <UpdateNotification />
            <Router basename="/">
              <AppContent isMobile={isMobile} />
            </Router>
          </UserProvider>
        </UpdateProvider>
      </ThemeProvider>
    </LocalizationProvider>
  );
}

function AppContent({ isMobile }: { isMobile: boolean }) {
  const location = useLocation();
  const isAuthPage = location.pathname === '/login' || location.pathname === '/register';
  
  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        p: 0,
        width: '100%',
        mt: isAuthPage ? 0 : isMobile ? 0 : 0,
      }}
    >
      <Routes>
        <Route
          path="/"
          element={
            isAuthenticated() ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/preview/:itnNo" element={<PreviewPage />} />

        
        <Route
          path="/itinerary-list"
          element={
            <ProtectedRoute>
              <ItineraryListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/itinerary-upload"
          element={
            <ProtectedRoute>
              <ItineraryUploadPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/itinerary-share"
          element={
            <ProtectedRoute>
              <ItinerarySharePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/itinerary-recycle"
          element={
            <ProtectedRoute>
              <ItineraryRecyclePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/company-info"
          element={
            <ProtectedRoute>
              <CompanyInfoPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employee-management"
          element={
            <ProtectedRoute>
              <EmployeeManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/favorite"
          element={
            <ProtectedRoute>
              <FavoritePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sitemap"
          element={
            <ProtectedRoute>
              <SiteMapPage />
            </ProtectedRoute>
          }
        />
        <Route path="/counseling" element={<CounselingListPage />} />
        <Route path="/customers" element={<CustomerListPage />} />
        
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Box>
  );
}

export default App;
